module.exports = __webpack_public_path__ + "static/media/EVC-valve.5c7660ab.svg";